import { render, staticRenderFns } from "./ConnectedToLabor.vue?vue&type=template&id=56ac601c&scoped=true&"
import script from "./ConnectedToLabor.vue?vue&type=script&lang=js&"
export * from "./ConnectedToLabor.vue?vue&type=script&lang=js&"
import style0 from "./ConnectedToLabor.vue?vue&type=style&index=0&id=56ac601c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56ac601c",
  null
  
)

export default component.exports